module.exports = __webpack_public_path__ + "static/img/frame 9.79ff6460.png";